import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from "gatsby-image";
import { withTranslation } from 'react-i18next';

const Employee = ({ employee, t }) => {
    const defaultEmployeeImage = useStaticQuery(graphql`
        query {
            file(relativePath: { eq: "placeholder-profile-sub.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 230) {
                        ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                }
            }
        }
    `);

    const {name, location, phone, email, image} = employee;
    const employeeImage = image ? image.imageFile.childImageSharp.fluid : defaultEmployeeImage.file.childImageSharp.fluid;
    const employeeAlt = image ? image.altText : t("distributor.employee.image-alt");

    return (
        <article className="c-employee">
            <Img className="c-employee__img" fluid={employeeImage} alt={employeeAlt}/>
            <h1 className="c-employee__title">{name}</h1>
            <ul className="c-employee__details-list">
                {email &&
                    <li className="c-employee__details-item c-distributor__contact-item__email">
                        <a href={`mailto:${email}`}>{email}</a>
                    </li>
                }
                {phone &&
                    <li className="c-employee__details-item c-distributor__contact-item__phone">
                        <a href={`tel:${phone}`} dangerouslySetInnerHTML={{ __html: phone}}></a>
                    </li>
                }
            </ul>
        </article>
    );
};

export default withTranslation()(Employee);
